var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Cell, Column, Row, TableBody, TableHeader } from "@react-stately/table";
import { KALEP_ACTIONS_COLUMN_KEY } from "../constants";
import { mapColumnHeaders } from "../utils/columns";
import { InternalCellContent } from "./CellContent";
import { TableView } from "./TableView";
export function Table(_a) {
    var { columns = {}, inlineActions, items, rowSelection, compact } = _a, props = __rest(_a, ["columns", "inlineActions", "items", "rowSelection", "compact"]);
    // This will change object -> array and sort pinned columns to the start
    const internalColumns = React.useMemo(() => {
        return mapColumnHeaders(columns, inlineActions);
    }, [columns, inlineActions]);
    return (React.createElement(TableView, Object.assign({}, props, { items: items, hasRowSelection: rowSelection, compact: compact }),
        React.createElement(TableHeader, { columns: internalColumns }, (columnDefinition) => {
            var _a;
            return (React.createElement(Column, { key: columnDefinition.kalepColumnKey, allowsSorting: columnDefinition.allowsSorting, width: columnDefinition.kalepColumnKey === KALEP_ACTIONS_COLUMN_KEY
                    ? (inlineActions || []).length * (compact ? 35 : 50)
                    : // This is a bit of a strange bit here, the old implementation expected value like "200px" here
                        // that it passed straight to the width style property. The new implementation expects a number, percentage string or fraction value.
                        columnDefinition.width, isRowHeader: columnDefinition.isPinned }, (_a = columnDefinition.label) !== null && _a !== void 0 ? _a : columnDefinition.kalepColumnKey));
        }),
        React.createElement(TableBody, { items: items, loadingState: props.isLoading ? "loading" : undefined }, (item) => (React.createElement(Row, { key: item.id }, (columnKey) => {
            var _a, _b;
            return (React.createElement(Cell, null,
                React.createElement(InternalCellContent, { columnKey: columnKey, item: item, inlineActions: inlineActions, isRowClickable: typeof props.onRowClick === "function", compact: compact, customRenderer: (_a = columns[columnKey]) === null || _a === void 0 ? void 0 : _a.renderCell, wrapRenderCellWithDefaultStyle: (_b = columns[columnKey]) === null || _b === void 0 ? void 0 : _b.wrapRenderCellWithDefaultStyle })));
        })))));
}
